/**
 * Harvest Mate - OEM Connection API
 *
 * Contact: servicedesk@clevvi.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { HarvesterFieldOperationsResponse } from '../model/harvester-field-operations-response';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class HarvesterFieldOperationsService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * List canonical field-operation summaries scoped to the caller.
     * Returns rows from &#x60;harvester_field_operation_summaries&#x60;, the canonical per-operation table populated by the SRA003-115 normaliser. This is the **Wave 3 read API** -- contractors and growers consume this to see field-ops telemetry sourced from Deere / CNH.  **Scoping (per Wave 1 master plan §\&quot;Multi-tenancy and data isolation\&quot; + D27):** - Contractor: filters on &#x60;contractor_id &#x3D; caller\&#39;s contractor_id&#x60; --   all rows for harvesters they own, across all growers\&#39; blocks. - Grower: filters on &#x60;grower_id &#x3D; caller\&#39;s grower_id&#x60; -- only their   own blocks, even when the harvester is shared with another grower   via the same contractor (multi-grower isolation property). - Admin: unscoped -- sees all rows (filtered by query params only). - Other roles: &#x60;403 forbidden&#x60;.  **Range semantics:** half-open &#x60;[from, to)&#x60; -- rows where &#x60;operation_started_at &gt;&#x3D; from AND &lt; to&#x60;. A row whose &#x60;operation_started_at&#x60; exactly equals &#x60;to&#x60; is excluded so callers can stitch adjacent windows without double-counting boundary rows (matches the Wave 1 convention).  **Range guard:** &#x60;from&#x60; and &#x60;to&#x60; are required; the server caps &#x60;to - from&#x60; at 365 days to bound query cost. Response items are ordered &#x60;operation_started_at&#x60; DESC. 
     * @endpoint get /harvester-field-operations
     * @param from ISO 8601 lower bound on &#x60;operation_started_at&#x60; (inclusive). Half-open semantics: &#x60;operation_started_at &gt;&#x3D; from&#x60;. 
     * @param to ISO 8601 upper bound on &#x60;operation_started_at&#x60; (exclusive). Half-open semantics: &#x60;operation_started_at &lt; to&#x60;. A row exactly at &#x60;to&#x60; is excluded. 
     * @param harvesterId Optional filter on &#x60;harvester_id&#x60; (HarvestMate canonical id).
     * @param blockId Optional filter on &#x60;block_id&#x60; (HarvestMate canonical id).
     * @param provider Optional filter on the source OEM provider.
     * @param limit Max number of rows to return. Default 100; capped at 200. Out-of-range or non-integer values silently clamp to the default. 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listHarvesterFieldOperations(from: string, to: string, harvesterId?: number, blockId?: number, provider?: 'deere' | 'cnh', limit?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HarvesterFieldOperationsResponse>;
    public listHarvesterFieldOperations(from: string, to: string, harvesterId?: number, blockId?: number, provider?: 'deere' | 'cnh', limit?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<HarvesterFieldOperationsResponse>>;
    public listHarvesterFieldOperations(from: string, to: string, harvesterId?: number, blockId?: number, provider?: 'deere' | 'cnh', limit?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<HarvesterFieldOperationsResponse>>;
    public listHarvesterFieldOperations(from: string, to: string, harvesterId?: number, blockId?: number, provider?: 'deere' | 'cnh', limit?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (from === null || from === undefined) {
            throw new Error('Required parameter from was null or undefined when calling listHarvesterFieldOperations.');
        }
        if (to === null || to === undefined) {
            throw new Error('Required parameter to was null or undefined when calling listHarvesterFieldOperations.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'from',
            <any>from,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'to',
            <any>to,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'harvester_id',
            <any>harvesterId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'block_id',
            <any>blockId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'provider',
            <any>provider,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'limit',
            <any>limit,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (cognito) required
        localVarHeaders = this.configuration.addCredentialToHeaders('cognito', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/harvester-field-operations`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<HarvesterFieldOperationsResponse>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
